import React, { Component } from 'react';
import { Button, Upload, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import './public-component.less';
import { AUDIO_UPLOAD_ERROR_MESSAGE, AUDIO_UPLOAD_SUCCESS_MESSAGE, DOCUMENT_UPLOAD_ERROR_MESSAGE, DOCUMENT_UPLOAD_SUCCESS_MESSAGE, 
         FILE_UPLOAD_ERROR_MESSAGE, FILE_UPLOAD_SUCCESS_MESSAGE, IMAGE_UPLOAD_ERROR_MESSAGE, IMAGE_UPLOAD_SUCCESS_MESSAGE, 
         UPLOAD_FILE_TYPE_ERROR_MESSAGE, VIDEO_UPLOAD_ERROR_MESSAGE, VIDEO_UPLOAD_SUCCESS_MESSAGE } from '../../config/strcfg';

interface FileUploadProps {
    fileType: FileType;
    multiFileMode?: boolean;
    onChange?: any,
    onRemove?: any,
}

interface FileUploadStates {
    fileList: any;
}

//支持上传的文件类型枚举定义（用于格式校验）
export enum FileType {  
    defualt = 0,//默认：任意类型
    image = 1,//图片
    video = 2,//视频
    audio = 3,//音频
    document = 4,//文档
}

//支持上传的图片文件类型
const imageSupportType = [                
    'image/png',
    'image/jpg',
    'image/jpeg',
    'image/gif',
    'image/webp',
    'image/bmp',
    'image/wemp',
    'image/tiff',
]
//支持上传的视频文件类型
const videoSupportType = [                
    '3g2','3gp',
    'avchd','avi','asf',
    'cpk',
    'div','dv','divx','dirac','dat',
    'f4v','flv','fli','flc',
    'lavf',
    'mp4','mkv','mov','mpg','mpeg','m4v','mpe','mod',
    'qt',
    'rm','rmvb','ram',
    'ts',
    'vob',
    'wmv','webm',
]

//根据上传文件的形式获取文件上传接口调用地址
const getReqAddress = (fileType: FileType) => {
    switch (fileType) {
        case FileType.image:
            return '/file/uploadLogo';
        case FileType.video:
            return ''; //TODO
        case FileType.audio:
            return ''; //TODO
        case FileType.document:
            return ''; //TODO
        default:
            return '/file/uploadFile';
    }
}

const getFileSupportTypeHint = (fileType: FileType) => {
    const hint = '支持文件类型: ';
    switch (fileType) {
        case FileType.image:
            return hint + imageSupportType.toString().replaceAll('image/',' ');
        case FileType.video:
            return ''; //TODO
        case FileType.audio:
            return ''; //TODO
        case FileType.document:
            return ''; //TODO
        default:
            return '';
    }
}

const getUploadMessage = (fileType: FileType, success: boolean) => {
    let message = '';
    switch (fileType) {
        case FileType.image:
            message = success ? IMAGE_UPLOAD_SUCCESS_MESSAGE : IMAGE_UPLOAD_ERROR_MESSAGE;
            break;
        case FileType.video:
            message = success ? VIDEO_UPLOAD_SUCCESS_MESSAGE : VIDEO_UPLOAD_ERROR_MESSAGE;
            break;
        case FileType.audio:
            message = success ? AUDIO_UPLOAD_SUCCESS_MESSAGE : AUDIO_UPLOAD_ERROR_MESSAGE;
            break;
        case FileType.document:
            message = success ? DOCUMENT_UPLOAD_SUCCESS_MESSAGE : DOCUMENT_UPLOAD_ERROR_MESSAGE;
            break;
        default:
            message = success ? FILE_UPLOAD_SUCCESS_MESSAGE : FILE_UPLOAD_ERROR_MESSAGE;
            break;
    }
    return message;
}

const isUploadTypeValid = (expectFileType: FileType, uploadFileType: string) => {
    switch (expectFileType) {
        case FileType.image:
            return imageSupportType.includes(uploadFileType.toLowerCase());

        case FileType.video:
            return videoSupportType.includes(uploadFileType.toLowerCase());

        case FileType.audio:
            return ''; //TODO

        case FileType.document:
            return ''; //TODO

        default:
            return true;
    }
}



class FileUpload extends Component<FileUploadProps> {
    state: FileUploadStates = {
        fileList: []
    };

    render() {

        //组件props定义
        const uploadProps = {
            action: getReqAddress(this.props.fileType),
            data: {},
            beforeUpload: (file) => {
                //判断文件类型是否正确
                if (!isUploadTypeValid(this.props.fileType, file.type)) {
                    message.error(UPLOAD_FILE_TYPE_ERROR_MESSAGE);
                    return false; // Reject the file upload
                }
                return true; // Allow the file upload
            },
            onChange: (fileInfo) => {
                if (fileInfo.file.status !== 'uploading') {
                    console.log(fileInfo.file, fileInfo.fileList);
                }
                this.setState({ fileList: fileInfo.fileList });
                if (fileInfo.fileList[fileInfo.fileList.length-1] && fileInfo.fileList[fileInfo.fileList.length-1].response) {
                    if (fileInfo.file.status === 'done') {
                        const { success, message: responseMessage, data } = fileInfo.fileList[fileInfo.fileList.length-1].response;
                        if (success) {
                            message.success(getUploadMessage(this.props.fileType, true));
                            //回传File信息给父页面
                            const { onChange: formCallback } = this.props;
                            if (typeof formCallback === 'function') {
                              formCallback(data);
                            }
                        } else {
                            message.error(responseMessage);
                        }
                    } else {
                        message.error(getUploadMessage(this.props.fileType, false));
                    }
                }
            },
            onRemove: () => {
                //清空回传给父页面的File信息
                const { onRemove: formCallback } = this.props;
                if (typeof formCallback === 'function') {
                    formCallback(null);
                }
            }
        };
        
        return (
            <>
                <Upload 
                    method="POST" 
                    {...uploadProps} 
                    listType="picture"
                >
                    {!this.props.multiFileMode && this.state.fileList.length >= 1 ? null :                     
                        <Button icon={ <UploadOutlined /> } type="ghost">点击上传</Button>
                    }
                </Upload>
                <p style={{ color: 'red', width: '405px', wordWrap: 'break-word' }}>{getFileSupportTypeHint(this.props.fileType)}</p>
            </>
        );
    }
}

export default FileUpload;